import { ApiBase } from "~/extensions/api";
import { GetAccountCommand } from "./commands/GetAccountCommand";
import { CreateAccountCommand } from "./commands/CreateAccountCommand";
import { UpdateAccountCommand } from "./commands/UpdateAccountCommand";
import { DeleteAccountCommand } from "./commands/DeleteAccountCommand";
export class AccountApi extends ApiBase {
    /** アカウント情報取得API */
    get(userCd) {
        let command = new GetAccountCommand(userCd);
        return this.request(command);
    }
    /** アカウント情報登録API */
    create(model) {
        let command = new CreateAccountCommand(model);
        return this.request(command);
    }
    /** アカウント情報更新API */
    async update(model) {
        let command = await UpdateAccountCommand.Create(model);
        return this.request(command);
    }
    /** アカウント情報削除API */
    delete(loginId) {
        let command = new DeleteAccountCommand(loginId);
        return this.request(command);
    }
}
